import React from 'react';
import {
  useSearchParams,
  useNavigate,
} from 'react-router-dom';
import {
  CSpinner,
  CCardTitle,
} from '@coreui/react-pro';
import {authorizeUserCredentials} from './auth-actions';
import logo from '../../../assets/images/premier-plus-logo-blue.png';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

//
// NOTRS Dev URL - Developer Backdoor - Use when testing Reports 
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA

// NOTRS Dev URL - Developer Backdoor with ability to override GrowId and EmailAddress
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=80912&emailAddressOverride=murrayfarms@gmail.com
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=100405&emailAddressOverride=skinkade@premiercooperative.net
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=63829&emailAddressOverride=dkshaffer@wirelessdatanet.net
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=23815&emailAddressOverride=sjeanfarm@yahoo.com
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=63002&emailAddressOverride=astierwalt21@gmail.com
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=1291&emailAddressOverride=wtimmons@ceres-asi.com
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=60133&emailAddressOverride=Bamusson@gmail.com
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=100120&emailAddressOverride=ehannagan@premiercooperative.net
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=64519&emailAddressOverride=gbruns@premiercooperative.net
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=22900&emailAddressOverride=thughes@premiercooperative.net
//
// Valid Grower URL - IsGrower=true
// http://localhost:3000/?growerId=6bmDqYk4AMK3Cw06%2BBLQ%2FQ%3D%3D&email=hHvWcB36tRwsb4p63NfM8D3p7SPexN%2B9MihaZvaum28%3D
//
// Invalid Grower URL - IsGrower=false
// http://localhost:3000/?growerId=sUe8l4R/MizrXgcBWG5LaQ%3D%3D&email=InkgrmV2NkFlK8EmMbOT45PbK7CnkxBd7AHRpNryT6Y%3D
//
// Yield Estimator Only Interface Backdoor URL
// http://localhost:3000/?growerId=3232G98A07DF4E8197D00C163CCYKBCF&email=1118FFAE1P07404695E53Y331754141EL
//
// Cash Bids Location Modal Backdoor URL
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=22900&emailAddressOverride=thughes@premiercooperative.net&cashBidsLocationId=Broadlands&bypassEmailValidation=0&isBuyGrainWidgetUser=1
// or without email address
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=22900&emailAddressOverride=null&cashBidsLocationId=Broadlands&bypassEmailValidation=1&isBuyGrainWidgetUser=1
//
// Purchase Contract Modal Backdoor URL
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=22900&emailAddressOverride=thughes@premiercooperative.net&cashBidsLocationId=Broadlands&bypassEmailValidation=0&isPurchaseContractModalUser=1&ContractType=Priced&Commodity=Corn
// or without email address
// http://localhost:3000/?growerId=5532498A06DF4E8197D20C163CC83BCF&email=2E18FFAE1037404695E53E23175001EA&growerIdOverride=22900&emailAddressOverride=null&cashBidsLocationId=Broadlands&bypassEmailValidation=1&isPurchaseContractModalUser=1&ContractType=Priced&Commodity=Corn
//


const Auth = () => {

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [queryParameters] = useSearchParams();

  const auth = useSelector(state => state.auth);

  React.useEffect(() => {
    const growerId = queryParameters.get('growerId');
    const emailAddress = queryParameters.get('email');
    const growerIdOverride = queryParameters.get('growerIdOverride');
    const emailAddressOverride = queryParameters.get('emailAddressOverride');
    const bypassEmailValidation = queryParameters.get('bypassEmailValidation');
    dispatch(authorizeUserCredentials(growerId, emailAddress, growerIdOverride, emailAddressOverride, bypassEmailValidation));
  }, [queryParameters]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    const isBuyGrainWidgetUser = queryParameters.get('isBuyGrainWidgetUser');
    const isPurchaseContractModalUser = queryParameters.get('isPurchaseContractModalUser');
    if (auth.authorizingUser === false && auth.authorization.isAuthorizedUser !== undefined) {
      if (auth.authorization.isAuthorizedUser === false) {
        window.location.replace(process.env.REACT_APP_USER_AUTH_FAILED_REDIRECT_URL);
      }
      else if (auth.authorization.isYieldEstimatorUser === true) {
        navigate('/premierplus/tool-box/yield-estimator');
      }
      else if (isBuyGrainWidgetUser !== undefined && isBuyGrainWidgetUser !== null && isBuyGrainWidgetUser === '1') {
        const cashBidsLocationId = queryParameters.get('cashBidsLocationId');
        dispatch({
          type: 'SET_IS_BUY_GRAIN_WIDGET_USER',
          isBuyGrainWidgetUser: true,
        });
        navigate('/premierplus/cash-bids?locationId=' + cashBidsLocationId);
      }
      else if (isPurchaseContractModalUser !== undefined && isPurchaseContractModalUser !== null && isPurchaseContractModalUser === '1') {
        const cashBidsLocationId = queryParameters.get('cashBidsLocationId');
        const contractType = queryParameters.get('ContractType');
        const commodity = queryParameters.get('Commodity');
        dispatch({
          type: 'SET_IS_PURCHASE_CONTRACT_MODAL_USER',
          isPurchaseContractModalUser: true,
        });
        navigate('/premierplus/cash-bids?locationId=' + cashBidsLocationId + '&contractType=' + contractType + '&commodity=' + commodity);
      }
      else {
        dispatch({
          type: 'SET_IS_BUY_GRAIN_WIDGET_USER',
          isBuyGrainWidgetUser: false,
        });
        dispatch({
          type: 'SET_IS_PURCHASE_CONTRACT_MODAL_USER',
          isPurchaseContractModalUser: false,
        });
        navigate('/premierplus/cash-bids');
      }
    }
  }, [auth.authorizingUser, auth.authorization.isAuthorizedUser]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div style={{width: '100vw', height: '50vh', display: 'flex', alignItems: 'flex-end', justifyContent: 'center',}}>
        <img src={logo} style={{width: 300, height: 'auto',}} alt='logo' />
      </div>
      <div style={{width: '100vw', height: '25vh', display: 'flex', alignItems: 'center', justifyContent: 'center',}}>
        <CCardTitle>Verifying User Access</CCardTitle>
      </div>
      <div style={{width: '100vw', height: '25vh', display: 'flex', alignItems: 'flex-start', justifyContent: 'center',}}>
        <CSpinner color='primary' variant='grow' />
        &nbsp;&nbsp;&nbsp;
        <CSpinner color='primary' variant='grow' />
        &nbsp;&nbsp;&nbsp;
        <CSpinner color='primary' variant='grow' />
      </div>
    </>
  );
}

export default Auth;
